import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { StaffService } from "../../services/staff.service";
import { IStaffItem } from "../../models/Staff";

export const useGetAllAdminsQuery = (searchValue: string | null) => {
  return useQuery<IStaffItem[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_ADMINS, searchValue],
    queryFn: () => StaffService.getAdminsList(searchValue).then((res) => res.data),
  });
};
